export const ITEM_VIEW_SUBHEADINGS = {
    'Single Day Event': 'Event has only one date',
    'Multi Day Event': 'Event has multiple dates',
  } as const;